import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CMSActions from "./store/actions";
import { animations } from "react-animation";

function BannerCert(props) {
  const dispatch = useDispatch();
  const [certificaciones, setCertificaciones] = useState([]);

  const { contentCertificaciones } = useSelector(
    ({ certificaciones }) => certificaciones.certificaciones
  );

  useEffect(() => {
    !contentCertificaciones && dispatch(CMSActions.getCertificaciones());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (contentCertificaciones) {
      let certs = contentCertificaciones.certificacion;
      certs.sort(function (a, b) {
        if (a.textoalternativo > b.textoalternativo) {
          return 1;
        }
        if (a.textoalternativo < b.textoalternativo) {
          return -1;
        }
        return 0;
      });
      setCertificaciones(certs);
    }
  }, [contentCertificaciones]);

  const root = process.env.REACT_APP_CMS_STATIC;
  const items = (
    <>
      {certificaciones.map((certificacion, index) => (
        <div key={index} className="d-flex flex-wrap mh150 p-5">
          <img
            key={index}
            src={root + certificacion.imagen.urls[0]}
            alt={certificacion.textoalternativo}
          />
        </div>
      ))}
    </>
  );
  return (
    <div
      className="d-flex justify-content-center maincontentwhite"
      style={{ animation: animations.fadeIn, marginTop: "auto" }}
    >
      <div className="d-flex flex-wrap justify-content-around align-items-center">
        {items}
      </div>
    </div>
  );
}

export default BannerCert;
